module.exports = __webpack_public_path__ + "img/黄柏.3f7dd80b.jpg";